const HEADER_SCROLL_PADDING_PX = 24;

const getHeaderOffset = () => {
  const header = document.querySelector('[data-header-container]');
  return (header?.offsetHeight || 0) + HEADER_SCROLL_PADDING_PX;
};

const preventEmbedFocusSteal = () => {
  document.querySelectorAll('iframe').forEach(iframe => {
    iframe.setAttribute('tabindex', '-1');
  });
};

const scrollToContactSuccess = successEl => {
  const top =
    successEl.getBoundingClientRect().top -
    document.body.getBoundingClientRect().top -
    getHeaderOffset();

  window.scrollTo({ top, behavior: 'auto' });
  successEl.focus({ preventScroll: true });
};

const initContactFormSuccess = () => {
  const successEl = document.getElementById('contact-form-success');
  if (!successEl) return;

  const showSuccess = () => {
    preventEmbedFocusSteal();

    if (window.location.hash) {
      history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    }

    scrollToContactSuccess(successEl);

    if (document.activeElement?.tagName === 'IFRAME') {
      document.activeElement.blur();
      scrollToContactSuccess(successEl);
    }
  };

  if (document.readyState === 'complete') {
    requestAnimationFrame(showSuccess);
    return;
  }

  window.addEventListener('load', showSuccess, { once: true });
};

export default initContactFormSuccess;
